import { render } from "./IntegrationPresetsLoader.vue?vue&type=template&id=f1cf0c18&ts=true"
import script from "./IntegrationPresetsLoader.vue?vue&type=script&lang=ts"
export * from "./IntegrationPresetsLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__